import React, { useState } from 'react';
import { Snackbar, Alert } from "@mui/material";
import { createContext } from 'react';

const ToastContext = createContext();  

const Toast = ({ message, type, open, setOpen }) => {
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}
    anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert severity={type} onClose={handleClose}>
        {message}
      </Alert>
    </Snackbar>
  );
}

const ToastProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("test");
  const [type, setType] = useState("success");

  const showToast = (message, type = "success") => {
    setMessage(message);
    setType(type);
    setOpen(true);
  };

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <Toast message={message} type={type} open={open} setOpen={setOpen} />
    </ToastContext.Provider>
  );
}

const useToast = () => {
  const context = React.useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  const showToast = (message, type) => {
    return context(message, type);
  };
  return showToast;
}

export { ToastProvider, useToast };
